import React, { useContext, useEffect, useState, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams, useLocation, useRouteMatch, Prompt } from "react-router-dom";
import Content from "../../../../common/content/Content";
import { Level } from "../../../../common/level";
import { GET } from "../../../../utils/fetchUtil";

import { MessageContext } from "../../../../common/message";
import { reducer } from "../previewDocuments/RequestPreviewDocumentsPageReducer";
import { checkProgress, buttonSetting } from "./PreviewDocumentsUtils";

import {
  Requests,
  Supplements,
  Attachments,
  Finances,
  Letters,
  AdditionalDocs,
  SupplementDocs,
} from "./RequestPreview";
import "../../../../common/progressBar/ProgresBar.scss";
import DocumentAcceptancePage from "./DocumentAcceptancePage";

function RequestPreviewDocumentsPage({ showTitle = true, isContainer = true }) {
  const { t } = useTranslation();
  const { id, uid } = useParams();
  const history = useHistory();
  const message = useContext(MessageContext);
  const location = useLocation();
  let { url } = useRouteMatch();
  const [state, dispatch] = useReducer(reducer, {
    isSupplement: null,
    progress: null,
    request: null,
    letters: [],
    attachments: [],
    supplements: [],
    finances: [],
    additionalDocs: [],
    supplementDocs: [],
    uploadConstraints: null,
    statusColor: null,
  });

  const [submitButton, setSubmitButton] = useState(true);
  const [progress, setProgress] = useState(0);
  const [supplement, setSupplement] = useState(false);

  const [selected, setSelected] = useState({
    preview: 0,
    document: null,
    index: null,
    additional: null,
    additionalIndex: null,
  });

  const [isBlocking, setIsBlocking] = useState(false);

  const [disabled] = useState(location.state === "yellow" ? true : false);

  useEffect(() => {
    GET(
      `/requests/${id}/submissions/${uid}`,
      (request) => {
        dispatch({ type: "init", payload: { ...request, statusColor: location.state } });
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [id, uid]);

  useEffect(() => {
    buttonSetting(state, setSubmitButton, setSupplement, setProgress, submitButton);
  }, [state, submitButton, progress, selected, isBlocking, supplement, state.additionalDocs]);

  useEffect(() => {
    if (submitButton === "svi zeleni") {
    } else {
      dispatch({ type: "supplement" });
    }
  }, [submitButton]);

  /* useEffect(() => {
      let counter = 0;
      if (state.request !== null) {
        if (state.request.color === "red") {
          counter++;
        }
      }
      if (state.attachments !== null) {
        state.attachments.forEach((attachment) => {
          if (attachment.color === "red") {
            counter++;
          }
        });
      }
      if (state.additionalDocs != null) {
        state.additionalDocs.forEach((additionalDoc) => {
          if (additionalDoc.label !== null) {
          counter++;
        }
      });
    }

    setSupplementEnabled(counter > 0 ? false : true);
  }, [state]);    */

  return (
    <>
      <Prompt
        when={isBlocking}
        message={() => "Želite li prekinuti sa obradom zahtjeva bez spremanja izmjena?"}
      />
      {selected.preview === 0 ? (
        <Content isContainer={isContainer}>
          {state.request && (
            <div className="section">
              <Requests
                showTitle={showTitle}
                state={state}
                progress={progress}
                url={url}
                setSelected={setSelected}
              />
              <Supplements state={state} url={url} setSelected={setSelected} />
              <Attachments state={state} url={url} setSelected={setSelected} />
              {/* <Finances state={state} url={url} setSelected={setSelected} /> */}
              <Letters state={state} url={url} setSelected={setSelected} />
              <AdditionalDocs
                pageState={state}
                setIsBlocking={setIsBlocking}
                disabled={disabled}
                setSelected={setSelected}
              />

              <SupplementDocs
                pageState={state}
                supplement={supplement}
                setIsBlocking={setIsBlocking}
                disabled={disabled}
                setSelected={setSelected}
              />

              <div className="block is-centered">
                {checkProgress(
                  message,
                  history,
                  setIsBlocking,
                  state,
                  t,
                  id,
                  uid,
                  submitButton,
                  disabled,
                  dispatch
                )}
              </div>
            </div>
          )}
        </Content>
      ) : (
        <DocumentAcceptancePage
          id={id}
          uid={uid}
          stated={state}
          document={selected.document}
          index={selected.index}
          additional={selected.additional}
          additionalIndex={selected.additionalIndex}
          setSelected={setSelected}
          setIsBlocking={setIsBlocking}
          disabled={disabled}
        />
      )}
    </>
  );
}

export default RequestPreviewDocumentsPage;
